import React from 'react';
import { Box } from '@mui/material';

/**
 * @typedef {Object} UsersInAGroupProps
 * @property {import('./GroupManagement').GroupData} usersInAGroup
 * @property {string} groupName
 * @property {(users: Array<OrgUser>, groupName: string) => React.JSX.Element} renderUsers
 */

/**
 *
 * @param {UsersInAGroupProps} props
 * @returns
 */
const UsersInAGroup = ({ usersInAGroup, groupName, renderUsers }) => {
  return (
    <Box
      sx={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {renderUsers(
        [
          ...(usersInAGroup?.paidTierUsers || []),
          ...(usersInAGroup?.connectTierUsers || []),
        ],
        groupName,
      )}
    </Box>
  );
};

export default UsersInAGroup;
